class MonogramBundleManager {
    constructor() {
        this.config = {
            selectors: {
                popup: "#monogram_popup",
                overlay: ".monogram_popup--overlay",
                wrapper: ".monogram_popup--wrapper",
                closeBtn: "#mngm_closePopup",
                stepBars: "#mngm_step_count .step_bar",
                stepCount: "[data-monogram-step-count]",
                nextBtn: "#next_button",
                backBtn: "#back_button",
                steps: ".mngm_step_item",
                designNames: '[data-designvariant-json]',
                container: '.mngm_step_content_container',
                bundleSwitcher: '#bundleFormSwitcher',
                bundleSwitcherContainer: '.bundle-switcher-container',
                nameInputs: '.name-input',
                nameCountSelect: '.name-count-input',
                nameInputContainers: '.step_option_naam_input',
                designShapeItems: '.mngm_design_shape_item',
                designSelectedValue: '[data-desing-selected-value]',
                designColorValue: '[data-desing-color-value]',
                designReview: '.desing_read_reviews',
                // Prefill selectors
                material: '.material_inputs',
                birthstone: '.birthstone_input',
                name: '#productName',
                style: '.existing_design_inputs',
                protection: '.protection_warrenty_input'
            },
            classes: {
                active: 'active',
                selected: 'selected',
                hidden: 'hidden',
                stepActive: 'active_step',
                stepBarActive: 'active_step_bar',
                bundleTabActive: 'active',
                bundleTabCompleted: 'completed',
                bundleTabInactive: 'inactive',
                designShapeActive: 'active'
            },
            events: {
                cartRefresh: 'cart:refresh',
                stepFormEdit: 'step_form_edit',
                bundleQuantityChange: 'bundle:quantity:change',
                bundleSelected: 'bundleSelected'
            }
        };

        this.elements = {};
        this.state = {
            currentStep: 0,
            currentBundleForm: 0,
            originalStepCount: 0,
            bundleCount: 1,
            designExist: false,
            namesOfArray: [],
            isEditing: false,
            bundleCompletion: {},
            formData: {},
            stepTypes: ['material', 'birthstone', 'name', 'design', 'protection'],
            previousBundleCount: 1,
            editBundleIndex: 0
        };

        this.cache = {
            preElement: null,
            customDesignElement: null,
            designVariants: null
        };

        this.leesmeerPopup = null;
        // this.formPrefill = new MonogramFormPrefill();
        this.init();
    }
    
    init() {
        this.initLeesmeer();
        this.cacheElements();
        this.setupBundleObserver();
        this.initializeState();
        this.initializeBundleForms();
        this.bindEvents();
    }

    cacheElements() {
        Object.keys(this.config.selectors).forEach(key => {
            const selector = this.config.selectors[key];
            this.elements[key] = document.querySelector(selector);
        });

        this.elements.steps = document.querySelectorAll(this.config.selectors.steps);
        this.elements.stepBars = document.querySelectorAll(this.config.selectors.stepBars);
        this.elements.isTemplateMoreUpsells = document.querySelector(".monogram-more-upsells");
        this.elements.isTemplateMoreUpsellsSec = document.querySelector(".monogram-more-upsells-v1");
    }

    initLeesmeer() {
        document.addEventListener('click', (e) => {
            if (e.target.closest('.mngm_leesmeer')) {
                this.leesmeerOpenPopup();
            }
        });

        document.addEventListener('click', (e) => {
            if (e.target.id === 'servicePopup') {
                this.leesmeerClosePopup();
            }
        });
    }

    setupBundleObserver() {
        if (this.elements.container) {
            this.bundleObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-active-quantity-bundle') {
                        const newBundleCount = parseInt(this.elements.container?.dataset.activeQuantityBundle) || 1;
                        this.handleBundleQuantityChange(newBundleCount);
                    }
                });
            });

            this.bundleObserver.observe(this.elements.container, {
                attributes: true,
                attributeFilter: ['data-active-quantity-bundle']
            });
        }
    }

    handleBundleQuantityChange(newBundleCount) {
        if (newBundleCount === this.state.previousBundleCount) {
            return;
        }
        
        // Save all current form states before rebuilding
        this.saveAllFormStates();
        
        this.state.bundleCount = newBundleCount;
        this.state.previousBundleCount = newBundleCount;
        
        this.rebuildBundleForms();
        
        document.dispatchEvent(new CustomEvent(this.config.events.bundleQuantityChange, {
            detail: { 
                bundleCount: newBundleCount,
                previousBundleCount: this.state.previousBundleCount
            }
        }));
    }

    saveAllFormStates() {
        for (let i = 0; i < this.state.bundleCount; i++) {
            const startingStep = i * this.state.originalStepCount;
            
            // Save material
            const materialStep = this.elements.steps[startingStep];
            const activeMaterial = materialStep?.querySelector(".material_inputs.active");
            const activeShape = materialStep?.querySelector(".mngm_design_shape_item.active");
            
            this.state.formData[i] = this.state.formData[i] || {};
            this.state.formData[i].material = activeMaterial?.dataset.name || '';
            this.state.formData[i].shape = activeShape?.dataset.desingShapeName || '';
            
            // Save birthstones
            const birthstoneStep = this.elements.steps[startingStep + 1];
            const activeBirthstones = birthstoneStep ? Array.from(birthstoneStep.querySelectorAll(".birthstone_input.active")) : [];
            this.state.formData[i].birthstones = activeBirthstones.map(el => el.dataset.value).join(", ");
            
            // Save names all name inputs
            const nameStep = this.elements.steps[startingStep + 2];
            if (nameStep) {
                const nameInputs = Array.from(nameStep.querySelectorAll(".step_option_naam_input.active .name-input"));
                this.state.formData[i].names = nameInputs.map((input, index) => {
                    const value = input.value.trim();
                    if (nameInputs.length === 1) return value;
                    return `#${index + 1}-Naam-[${value}]`;
                }).filter(name => name).join(", ");
            }
            
            // Save design
            const designStep = this.elements.steps[startingStep + 3];
            const activeDesign = designStep?.querySelector(".input_name_design.active");
            this.state.formData[i].design = activeDesign?.dataset.designName || '';
            
            // Save completion status
            this.state.formData[i].completed = this.checkBundleCompletionFor(i);
        }
    }

    rebuildBundleForms() {
        const container = this.elements.container;
        if (!container) return;

        // Get original steps
        const originalSteps = Array.from(container.querySelectorAll('.mngm_step_item')).slice(0, this.state.originalStepCount);
        
        // Remove all duplicated steps
        const allSteps = Array.from(container.querySelectorAll('.mngm_step_item'));
        allSteps.forEach((step, index) => {
            if (index >= this.state.originalStepCount) {
                step.remove();
            }
        });

        // Reset bundle completion states
        this.state.bundleCompletion = {};
        for (let i = 0; i < this.state.bundleCount; i++) {
            this.state.bundleCompletion[i] = false;
            if (!this.state.formData[i]) {
                this.state.formData[i] = {
                    material: '',
                    shape: '',
                    names: '',
                    design: '',
                    birthstones: '',
                    completed: false
                };
            }
        }

        // Create duplicated steps for additional bundles
        if (this.state.bundleCount > 1) {
            for (let bundleIndex = 1; bundleIndex < this.state.bundleCount; bundleIndex++) {
                originalSteps.forEach((originalStep, stepIndex) => {
                    const clonedStep = this.cloneStep(originalStep, bundleIndex, stepIndex);
                    container.appendChild(clonedStep);
                });
            }
        }

        // Update steps reference
        this.elements.steps = container.querySelectorAll('.mngm_step_item');
        
        // Reset to first step
        this.state.currentStep = 0;
        this.state.currentBundleForm = 0;
        
        // Reinitialize
        this.initializeBundleForms();
        this.showStep(0);
        this.updateButtonStates();
    }

    initializeState() {
        this.parseDesignNames();
        this.cacheDesignElements();
        this.initializeBundleCount();
        this.initializeFormData();
        this.calculateOriginalStepCount();
        this.duplicateSteps();
        this.initializeSteps();
        this.updateButtonStates();
    }

    initializeBundleCount() {
        const container = this.elements.container;
        if (!container) return;

        this.state.bundleCount = parseInt(container.dataset.activeQuantityBundle) || 1;
        this.state.previousBundleCount = this.state.bundleCount;
        this.elements.popup.classList.add("bundle_popup_enabled")
        
        for (let i = 0; i < this.state.bundleCount; i++) {
            this.state.bundleCompletion[i] = false;
            this.state.formData[i] = {
                material: '',
                shape: '',
                names: '',
                design: '',
                birthstones: '',
                completed: false
            };
        }
    }

    calculateOriginalStepCount() {
        const uniqueStepTypes = new Set();
        const container = this.elements.container;
        if (!container) return;

        const originalSteps = Array.from(container.querySelectorAll('.mngm_step_item'));
        originalSteps.forEach(step => {
            const stepType = step.dataset.stepType;
            if (stepType) {
                uniqueStepTypes.add(stepType);
            }
        });
        this.state.originalStepCount = uniqueStepTypes.size;
    }

    initializeFormData() {
        for (let i = 0; i < this.state.bundleCount; i++) {
            this.state.formData[i] = {
                material: '',
                shape: '',
                names: '',
                design: '',
                birthstones: '',
                completed: false
            };
        }
    }

    initializeBundleForms() {
        if (this.state.bundleCount <= 1) {
            if (this.elements.bundleSwitcher) {
                this.elements.bundleSwitcher.style.display = 'none';
            }
            return;
        }

        this.createBundleSwitcher();
        if (this.elements.bundleSwitcher) {
            this.elements.bundleSwitcher.style.display = 'block';
        }
        this.updateBundleSwitcher();
    }

    createBundleSwitcher() {
        const container = this.elements.bundleSwitcherContainer;
        if (!container) return;

        container.innerHTML = '';
        
        for (let i = 0; i < this.state.bundleCount; i++) {
            const tab = document.createElement('div');
            tab.className = `bundle-form-tab ${i === 0 ? this.config.classes.bundleTabActive : this.config.classes.bundleTabInactive}`;
            tab.dataset.bundleIndex = i;
            tab.innerHTML = `
                <div class="bundle-step-indicator">
                    <span class="step-number">${i + 1}</span>
                    <svg class="checkmark-icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                    </svg>
                </div>
                <span class="bundle-form-title">Sieraad ${i + 1}</span>
            `;
            
            tab.addEventListener('click', () => this.switchBundleForm(i));
            container.appendChild(tab);
        }
    }

    switchBundleForm(bundleIndex) {
        if (bundleIndex < 0 || bundleIndex >= this.state.bundleCount) return;
        
        this.saveCurrentFormState();
        this.state.currentBundleForm = bundleIndex;
        const startingStep = bundleIndex * this.state.originalStepCount;
        this.showStep(startingStep);
        this.updateBundleSwitcher();
    }

    saveCurrentFormState() {
        const currentBundle = this.state.currentBundleForm;
        const startingStep = currentBundle * this.state.originalStepCount;
        
        // Save material and shape
        const materialStep = this.elements.steps[startingStep];
        const activeMaterial = materialStep?.querySelector(".material_inputs.active");
        const activeShape = materialStep?.querySelector(".mngm_design_shape_item.active");
        
        this.state.formData[currentBundle].material = activeMaterial?.dataset.name || '';
        this.state.formData[currentBundle].shape = activeShape?.dataset.desingShapeName || '';
        
        // Save birthstones
        const birthstoneStep = this.elements.steps[startingStep + 1];
        const activeBirthstones = birthstoneStep ? Array.from(birthstoneStep.querySelectorAll(".birthstone_input.active")) : [];
        this.state.formData[currentBundle].birthstones = activeBirthstones.map(el => el.dataset.value).join(", ");
        
        // Save names - FIXED: Properly handle all name inputs
        const nameStep = this.elements.steps[startingStep + 2];
        if (nameStep) {
            const nameInputs = Array.from(nameStep.querySelectorAll(".step_option_naam_input.active .name-input"));
            this.state.formData[currentBundle].names = nameInputs.map((input, index) => {
                const value = input.value.trim();
                if (nameInputs.length === 1) return value;
                return `#${index + 1}-Naam-[${value}]`;
            }).filter(name => name).join(", ");
        }
        
        // Save design
        const designStep = this.elements.steps[startingStep + 3];
        const activeDesign = designStep?.querySelector(".input_name_design.active");
        this.state.formData[currentBundle].design = activeDesign?.dataset.designName || '';
        
        // Save completion status
        this.state.formData[currentBundle].completed = this.checkBundleCompletionFor(currentBundle);
    }

    updateBundleSwitcher() {
        const tabs = this.elements.bundleSwitcherContainer?.querySelectorAll('.bundle-form-tab');
        if (!tabs) return;

        tabs.forEach((tab, index) => {
            tab.classList.remove(
                this.config.classes.bundleTabActive, 
                this.config.classes.bundleTabCompleted,
                this.config.classes.bundleTabInactive
            );
            
            if (index === this.state.currentBundleForm) {
                tab.classList.add(this.config.classes.bundleTabActive);
            } else if (this.state.bundleCompletion[index]) {
                tab.classList.add(this.config.classes.bundleTabCompleted);
            } else {
                tab.classList.add(this.config.classes.bundleTabInactive);
            }
        });
    }

    checkBundleCompletion() {
        const bundleIndex = this.state.currentBundleForm;
        return this.checkBundleCompletionFor(bundleIndex);
    }

    checkBundleCompletionFor(bundleIndex) {
        const startingStep = bundleIndex * this.state.originalStepCount;
        const endingStep = startingStep + this.state.originalStepCount;
        
        let allStepsCompleted = true;
        
        for (let step = startingStep; step < endingStep; step++) {
            if (!this.isStepCompleted(step)) {
                allStepsCompleted = false;
                break;
            }
        }
        
        this.state.bundleCompletion[bundleIndex] = allStepsCompleted;
        this.updateBundleSwitcher();
        
        return allStepsCompleted;
    }

    isStepCompleted(stepIndex) {
        const step = this.elements.steps[stepIndex];
        if (!step) return false;

        // Optional steps are always considered completed
        if (step.dataset.optionalStep === 'true') {
            return true;
        }

        // Material step validation - check both material and shape are selected
        if (step.dataset.stepType === 'material') {
            const activeMaterial = step.querySelector(".material_inputs.active");
            const activeShape = step.querySelector(".mngm_design_shape_item.active");
            return !!(activeMaterial && activeShape);
        }

        // Name step validation - FIXED: Check all active name inputs
        if (step.dataset.stepType === 'name') {
            const activeNameInputs = step.querySelectorAll('.step_option_naam_input.active .name-input');
            const allFilled = Array.from(activeNameInputs).every(input => {
                return input.value.trim() !== '';
            });
            return allFilled;
        }

        // Other steps validation
        const radioButtons = step.querySelectorAll('[data-radio-input].active');
        return radioButtons.length > 0;
    }

    duplicateSteps() {
        const container = this.elements.container;
        if (!container) return;

        if (this.state.bundleCount <= 1) {
            return;
        }

        const originalSteps = Array.from(this.elements.steps).slice(0, this.state.originalStepCount);
        
        for (let bundleIndex = 1; bundleIndex < this.state.bundleCount; bundleIndex++) {
            originalSteps.forEach((originalStep, stepIndex) => {
                const clonedStep = this.cloneStep(originalStep, bundleIndex, stepIndex);
                container.appendChild(clonedStep);
            });
        }
        
        this.elements.steps = container.querySelectorAll('.mngm_step_item');
    }

    cloneStep(originalStep, bundleIndex, stepIndex) {
        const clonedStep = originalStep.cloneNode(true);
        const newIndex = (bundleIndex * this.state.originalStepCount) + stepIndex;

        clonedStep.dataset.bundleIndex = bundleIndex;
        clonedStep.dataset.stepIndex = stepIndex;
        clonedStep.dataset.originalIndex = newIndex;
        clonedStep.classList.remove(this.config.classes.stepActive);
        clonedStep.style.cssText = "transform: translateX(-100%); opacity: 0; transition: transform 0.4s ease, opacity 0.3s ease";
        
        this.resetActiveStates(clonedStep);
        this.makeInputsUnique(clonedStep, bundleIndex, stepIndex);
        
        // FIXED: Ensure name inputs are properly initialized in duplicated steps
        if (clonedStep.dataset.stepType === 'name') {
            this.initializeNameStep(clonedStep);
        }
        
        return clonedStep;
    }

    // Initialize name step with proper event handlers
    initializeNameStep(nameStep) {
        const nameInputs = nameStep.querySelectorAll(this.config.selectors.nameInputs);
        const nameCountSelect = nameStep.querySelector(this.config.selectors.nameCountSelect);
        const nameInputContainers = nameStep.querySelectorAll(this.config.selectors.nameInputContainers);

        // Initialize name inputs
        nameInputs.forEach(input => {
            input.value = '';
            input.addEventListener('input', () => {
                this.updateButtonStates();
                if (this.validateCurrentStep()) {
                    this.handleDesignSuggestion();
                }
            });
        });

        // Initialize name count select
        if (nameCountSelect) {
            nameCountSelect.value = '1';
            nameCountSelect.addEventListener('change', (e) => {
                this.handleNameCountChange(e);
            });
        }

        // Initialize name input containers
        nameInputContainers.forEach((container, index) => {
            if (index === 0) {
                container.classList.add(this.config.classes.active);
                container.classList.remove("mngm_d_none");
            } else {
                container.classList.remove(this.config.classes.active);
                container.classList.add("mngm_d_none");
            }
        });
    }

    makeInputsUnique(container, bundleIndex, stepIndex) {
        if (container.dataset.stepType === 'name') {
            const nameInputs = container.querySelectorAll('.name-input');
            nameInputs.forEach((input, index) => {
                input.id = `productName_${bundleIndex}_${index}`;
                input.name = `productName_${bundleIndex}_${index}`;
            });

            const nameCountSelect = container.querySelector('.name-count-input');
            if (nameCountSelect) {
                nameCountSelect.id = `nameCount_${bundleIndex}`;
                nameCountSelect.name = `nameCount_${bundleIndex}`;
            }
        }
    }

    resetActiveStates(container) {
        const activeSelectors = [`.${this.config.classes.active}`, `.${this.config.classes.selected}`, `.${this.config.classes.designShapeActive}`, '[data-radio-input].active'];
        
        activeSelectors.forEach(selector => {
            container.querySelectorAll(selector).forEach(element => {
                element.classList.remove(this.config.classes.active, this.config.classes.selected, this.config.classes.designShapeActive);
            });
        });
    }

    initializeSteps() {
        this.elements.steps.forEach((step, index) => {
            step.style.transition = "transform 0.4s ease, opacity 0.3s ease";

            if (index === 0) {
                this.activateStep(step);
            } else {
                this.deactivateStep(step);
            }
        });
    }

    showStep(index) {
        if (!this.isValidStepIndex(index)) return;
        
        this.deactivateStep(this.elements.steps[this.state.currentStep]);
        this.activateStep(this.elements.steps[index]);
        
        this.updateStepDisplay(index);
        this.state.currentStep = index;
        this.state.currentBundleForm = Math.floor(index / this.state.originalStepCount);
        this.updateBundleSwitcher();
        this.updateButtonStates();
        this.handleNextButtonReplacement();
    }

    isValidStepIndex(index) {
        return index >= 0 && index < this.elements.steps.length;
    }

    activateStep(step) {
        if (!step) return;
        
        step.classList.add(this.config.classes.stepActive);
        step.style.transform = "translateX(0)";
        step.style.opacity = "1";
    }

    deactivateStep(step) {
        if (!step) return;
        
        step.classList.remove(this.config.classes.stepActive);
        step.style.transform = "translateX(-100%)";
        step.style.opacity = "0";
    }

    updateStepDisplay(stepIndex) {
        this.updateStepCount(stepIndex);
        this.updateStepBars(stepIndex);
        this.updateMonogramStepAttribute(stepIndex);
    }

    updateStepCount(stepIndex) {
        if (!this.elements.stepCount) return;
        
        const stepInBundle = (stepIndex % this.state.originalStepCount) + 1;
        this.elements.stepCount.textContent = stepInBundle;
    }

    updateStepBars(stepIndex) {
        this.elements.stepBars?.forEach((bar, barIndex) => {
            const currentStepInBundle = stepIndex % this.state.originalStepCount;
            bar.classList.toggle(this.config.classes.stepBarActive, barIndex < currentStepInBundle);
        });
    }

    updateMonogramStepAttribute(stepIndex) {
        if (this.elements.popup) {
            this.elements.popup.dataset.monogramStep = (stepIndex % this.state.originalStepCount) + 1;
        }
    }

    handleNextButtonReplacement() {
        const isLastStepInAllBundles = this.state.currentStep === this.elements.steps.length - 1;
        
        if (isLastStepInAllBundles) {
            this.replaceNextButtonWithAddToCart();
        } else {
            this.restoreNextButton(); 
        }
    }

    replaceNextButtonWithAddToCart() {
        if (document.querySelector("#addToCart")) return;

        this.elements.nextBtn.style.display = "none";
        
        const addToCartBtn = this.createAddToCartButton();
        this.elements.nextBtn.parentNode.insertBefore(addToCartBtn, this.elements.nextBtn.nextSibling);
        
        this.updateAddToCartPrice(addToCartBtn);
        addToCartBtn.addEventListener("click", () => this.handleAddToCart());
    }

    createAddToCartButton() {
        const productPrice = this.elements.popup?.dataset.productPrice || '';
        const button = document.createElement("button");
        
        button.id = "addToCart";
        button.type = "button";
        button.disabled = !this.isAllBundlesCompleted();
        button.className = "continue-btn button button--primary";
        button.tabIndex = 0;
        button.innerHTML = this.getAddToCartButtonHTML(productPrice);
        
        return button;
    }

    isAllBundlesCompleted() {
        for (let i = 0; i < this.state.bundleCount; i++) {
            if (!this.checkBundleCompletionFor(i)) {
                return false;
            }
        }
        return true;
    }

    getAddToCartButtonHTML(price) {
        return `
            ${this.elements.nextBtn?.dataset.atcText || 'Add to Cart'} &nbsp; 
            <span class='tgprice'>${price}</span>
            <div class="loading__spinner ${this.config.classes.hidden}">
                <svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
                </svg>
            </div>
        `;
    }

    updateAddToCartPrice(button) {
        const priceElement = button.querySelector(".tgprice");
        if (priceElement && this.elements.popup?.dataset.monogramProductPrice) {
            const formattedPrice = Shopify.formatMoney(
                this.elements.popup.dataset.monogramProductPrice, 
                window.money_format
            );
            priceElement.textContent = formattedPrice;
        }
    }

    restoreNextButton() {
        this.elements.nextBtn.style.display = "";
        const addToCartBtn = document.querySelector("#addToCart");
        addToCartBtn?.remove();
    }

    validateCurrentStep() {
        const currentStep = this.elements.steps[this.state.currentStep];
        if (!currentStep) return false;

        if (currentStep.dataset.optionalStep === 'true') {
            return true;
        }

        // Material step validation - check both material and shape are selected
        if (currentStep.dataset.stepType === 'material') {
            const activeMaterial = currentStep.querySelector(".material_inputs.active");
            const activeShape = currentStep.querySelector(".mngm_design_shape_item.active");
            return !!(activeMaterial && activeShape);
        }

        // Name step validation for all bundles
        if (currentStep.dataset.stepType === 'name') {
            const activeNameInputs = currentStep.querySelectorAll('.step_option_naam_input.active .name-input');
            const allFilled = Array.from(activeNameInputs).every(input => {
                const value = input.value.trim();
                return value !== '';
            });
            return allFilled;
        }

        const radioButtons = currentStep.querySelectorAll('[data-radio-input].active');
        return radioButtons.length > 0;
    }

    updateButtonStates() {
        if (!this.elements.backBtn || !this.elements.nextBtn) return;

        const isFirstStep = this.state.currentStep === 0;
        this.elements.backBtn.disabled = isFirstStep;
        this.elements.backBtn.classList.toggle('mngm_d_none', isFirstStep);
        this.elements.nextBtn.disabled = !this.validateCurrentStep();

        this.updateAddToCartButtonState();
    }

    updateAddToCartButtonState() {
        const addToCartBtn = document.querySelector("#addToCart");
        if (addToCartBtn) {
            addToCartBtn.disabled = !this.isAllBundlesCompleted();
        }
    }

    handleNextButtonClick() {
        if (this.state.currentStep < this.elements.steps.length - 1) {
            this.saveCurrentFormState();
            this.checkBundleCompletion();
            this.showStep(this.state.currentStep + 1);
        }
    }

    async handleAddToCart() {
        if (!this.isAllBundlesCompleted()) return;

        try {
            this.saveCurrentFormState();
            const formData = this.prepareFormData();
            
            await this.submitAddToCart(formData);
            
            this.handleSuccess();
        } catch (error) {
            this.handleAddToCartError(error);
        }
    }

    collectAllProductData() {
        const allProductData = [];
        
        for (let bundleIndex = 0; bundleIndex < this.state.bundleCount; bundleIndex++) {
            const productData = this.collectProductDataForBundle(bundleIndex);
            allProductData.push(productData);
        }
        
        return allProductData;
    }

    collectProductDataForBundle(bundleIndex) {
        // Use saved form data if available
        if (this.state.formData[bundleIndex] && this.state.formData[bundleIndex].material) {
            return this.state.formData[bundleIndex];
        }
        
        // Fallback to collecting from DOM
        const startingStep = bundleIndex * this.state.originalStepCount;
        
        const materialStep = this.elements.steps[startingStep];
        const material = materialStep?.querySelector(".material_inputs.active")?.dataset.name || '';
        const shape = materialStep?.querySelector(".mngm_design_shape_item.active")?.dataset.shapeName || '';
        
        const nameStep = this.elements.steps[startingStep + 2];
        const nameInputs = nameStep ? Array.from(nameStep.querySelectorAll(".step_option_naam_input.active .name-input")) : [];
        const names = nameInputs.map((input, index) => {
            const value = input.value.trim();
            if (nameInputs.length === 1) return value;
            return `#${index + 1}-Naam-[${value}]`;
        }).filter(name => name).join(", ");
        
        const designStep = this.elements.steps[startingStep + 3];
        const design = designStep?.querySelector(".input_name_design.active")?.dataset.designName || '';
        
        const birthstoneStep = this.elements.steps[startingStep + 1];
        const birthstoneElements = birthstoneStep ? Array.from(birthstoneStep.querySelectorAll(".birthstone_input.active")) : [];
        const birthstones = birthstoneElements.map(el => el.dataset.value).join(", ");
        
        return {
            material,
            shape,
            names,
            design,
            birthstones,
            completed: this.checkBundleCompletionFor(bundleIndex)
        };
    }

    prepareFormData() {
        const atcForm = document.querySelector(`.main-product-form[data-type="add-to-cart-form"]`);
        if (!atcForm) throw new Error('Add to cart form not found');

        this.cleanExistingFormInputs(atcForm);
        
        const allProductData = this.collectAllProductData();
        this.addBundleFormInputs(atcForm, allProductData);

        return new FormData(atcForm);
    }

    addBundleFormInputs(form, allProductData) {
        const sharedUniqueId = this.generateUniqueId();
        let itemIndex = 0;

        itemIndex = this.addUpsellProducts(form, itemIndex, sharedUniqueId);
        itemIndex = this.addProtectionProducts(form, itemIndex, sharedUniqueId);
        
        allProductData.forEach((productData, bundleIndex) => {
            itemIndex = this.addBirthstoneProductsForBundle(form, itemIndex, sharedUniqueId, bundleIndex);
            this.addMainProductForBundle(form, itemIndex, sharedUniqueId, productData, bundleIndex);
            itemIndex++;
        });
    }

    addUpsellProducts(form, startIndex, uniqueId) {
        const upsellElements = document.querySelectorAll(".upsell_input.active");
        return this.addProductElements(form, upsellElements, startIndex, uniqueId);
    }

    addProtectionProducts(form, startIndex, uniqueId) {
        const protectionElements = document.querySelectorAll(".protection_warrenty_input.active");
        return this.addProductElements(form, protectionElements, startIndex, uniqueId);
    }

    addBirthstoneProductsForBundle(form, startIndex, uniqueId, bundleIndex) {
        const startingStep = bundleIndex * this.state.originalStepCount;
        const birthstoneStep = this.elements.steps[startingStep + 1];
        
        if (!birthstoneStep) return startIndex;
        
        const birthstoneElements = birthstoneStep.querySelectorAll(".birthstone_input.active");
        let currentIndex = startIndex;
        
        birthstoneElements.forEach(element => {
            this.addVariantInput(form, currentIndex, element.dataset.productVariantId);
            this.addPropertyInput(form, currentIndex, '_product_key', uniqueId);
            this.addPropertyInput(form, currentIndex, '_bundle_index', bundleIndex.toString());
            currentIndex++;
        });
        
        return currentIndex;
    }

    addProductElements(form, elements, startIndex, uniqueId) {
        let currentIndex = startIndex;
        
        elements.forEach(element => {
            this.addVariantInput(form, currentIndex, element.dataset.productVariantId);
            this.addPropertyInput(form, currentIndex, '_product_key', uniqueId);
            currentIndex++;
        });
        
        return currentIndex;
    }

    addMainProductForBundle(form, index, uniqueId, productData, bundleIndex) {
        const mainProductId = this.elements.popup?.dataset.productVariantId;
        if (!mainProductId) return;

        this.addVariantInput(form, index, mainProductId);
        this.addPropertyInput(form, index, '_product_key', uniqueId);
        this.addPropertyInput(form, index, '_bundle_index', bundleIndex.toString());
        
        this.addDesignImageForBundle(form, index, bundleIndex);
        
        Object.entries(this.getProductProperties(productData)).forEach(([key, value]) => {
            this.addPropertyInput(form, index, key, value);
        });
    }

    getProductProperties(productData) {
        return {
            "Materiaal": productData.material,
            "Vorm": productData.shape, 
            "Naam": productData.names, 
            "Stijl": productData.design,
            "Geboortesteen": productData.birthstones
        };
    }

    addDesignImageForBundle(form, index, bundleIndex) {
        const startingStep = bundleIndex * this.state.originalStepCount;
        const designStep = this.elements.steps[startingStep + 3];
        
        if (!designStep) return;
        
        const activeDesignElement = designStep.querySelector(".input_name_design.active");
        if (!activeDesignElement) return;

        const designName = activeDesignElement.dataset.designName;
        const designImg = activeDesignElement.querySelector("img")?.src;

        if (designImg && designName !== "Custom") {
            this.addPropertyInput(form, index, '_active_design_img', designImg);
        }
    }

    addVariantInput(form, index, variantId) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `items[${index}][id]`;
        input.value = variantId;
        input.className = 'product-variant-id';
        form.appendChild(input);
    }

    addPropertyInput(form, index, key, value) {
        if (!value) return;
        
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `items[${index}][properties][${key}]`;
        input.value = value;
        input.className = 'product-variant-properties';
        form.appendChild(input);
    }

    cleanExistingFormInputs(form) {
        form.querySelectorAll(".product-variant-properties, .product-variant-id").forEach(input => input.remove());
    }

    generateUniqueId() {
        return Math.floor(100000000000 + Math.random() * 900000000000).toString();
    }

    async submitAddToCart(formData) {
        const atcBtn = document.querySelector("#addToCart");
        if (!atcBtn) throw new Error('Add to cart button not found');

        this.showLoadingState(atcBtn);

        if (this.state.isEditing) {
            await this.delay(2000);
            this.state.isEditing = false;
            this.elements.popup?.removeAttribute("data-edit-form-id");
        }

        const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.text();
            throw new Error(`Add to cart failed: ${error}`);
        }

        return response;
    }

    showLoadingState(button) {
        const spinner = button.querySelector(".loading__spinner");
        spinner?.classList.remove(this.config.classes.hidden);
        button.style.opacity = "0.5";
        button.style.pointerEvents = "none";
    }

    hideLoadingState(button) {
        const spinner = button.querySelector(".loading__spinner");
        spinner?.classList.add(this.config.classes.hidden);
        button.style.opacity = "1";
        button.style.pointerEvents = "auto";
    }

    handleSuccess() {
        this.closePopup();
        this.resetToFirstStep();
        this.triggerCartRefresh();

        this.state.isEditing = false;
        this.state.editBundleIndex = 0;
        
        if (this.elements.popup) {
            this.elements.popup.removeAttribute("data-edit-form-id");
        }
    }

    handleAddToCartError(error) {
        console.error('Error adding to cart:', error);
        this.hideLoadingState(document.querySelector("#addToCart"));
        alert('There was an error adding the product to your cart. Please try again.');
    }

    delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    handleRadioSelection(radio) {
        const popupInner = radio.closest("[data-mngm-popup-inner]");
        const step = radio.closest('.mngm_step_item');
        
        if (radio.classList.contains("birthstone_input")) {
            this.handleBirthstoneSelection(radio, popupInner);
            this.updateBirthstoneImageForStep(step);
        } else if (radio.classList.contains("upsell_input") || radio.classList.contains("protection_warrenty_input")) {
            radio.classList.toggle(this.config.classes.active);
        } else if (radio.classList.contains("material_inputs")) {
            this.clearActiveRadios(popupInner, 'material_inputs');
            radio.classList.add(this.config.classes.active);
            this.updateMaterialSelectionDisplay(radio);
            this.updateAllBirthstoneImages();
        } else if (radio.classList.contains("mngm_design_shape_item")) {
            this.handleDesignShapeSelection(radio, popupInner);
        } else {
            this.clearActiveRadios(popupInner);
            radio.classList.add(this.config.classes.active);
        }

        this.updatePriceDisplays(this.calculateTotalPrice());
        this.updateButtonStates();
    }

    handleDesignShapeSelection(shapeElement, popupInner) {
        this.clearActiveRadios(popupInner, 'mngm_design_shape_item');
        shapeElement.classList.add(this.config.classes.designShapeActive);
        
        this.updateShapeSelectionDisplay(shapeElement);
    }

    updateShapeSelectionDisplay(shapeElement) {
        const designName = shapeElement.dataset.desingShapeName;
        const shapeName = shapeElement.dataset.shapeName;
        
        const popupInner = shapeElement.closest("[data-mngm-popup-inner]");
        const materialName = popupInner?.querySelector(".material_inputs.active")?.dataset.matrialName || 'silver';

        const selectedValueElement = popupInner?.querySelector(this.config.selectors.designSelectedValue);
        if (selectedValueElement) {
            selectedValueElement.textContent = designName;
        }

        this.updateMaterialShapeMainImage(shapeName, popupInner, materialName);
    }
    
    updateMaterialSelectionDisplay(materialElement) {
        const designMaterialName = materialElement.dataset.name;
        const matrialName = materialElement.dataset.matrialName;

        const popupInner = materialElement.closest("[data-mngm-popup-inner]");
        const selectedValueElement = popupInner?.querySelector(this.config.selectors.designColorValue);
        const shapeName = popupInner?.querySelector(".mngm_design_shape_item.active")?.dataset.shapeName || 'circle';
        
        if (selectedValueElement) {
            selectedValueElement.textContent = designMaterialName;
        }
        
        this.updateMaterialShapeMainImage(shapeName, popupInner, matrialName);
    }

    updateMaterialShapeMainImage(shapeName, popupInner, matrialName) {
        const popupImage = popupInner?.querySelector(".mongm_material_shape_img img");
        popupImage.src = `/cdn/shop/files/shape_material_${shapeName}_${matrialName}.png?&width=572`;        
    }

    handleBirthstoneSelection(radio, popupInner) {
        if (this.elements.isTemplateMoreUpsellsSec) {
            this.handleMultiBirthstoneSelection(radio, popupInner);
        } else {
            this.handleSingleBirthstoneSelection(radio, popupInner);
        }
    }

    handleMultiBirthstoneSelection(radio, popupInner) {
        const maxSelections = 5;
        const birthstoneRadios = popupInner.querySelectorAll(".birthstone_input");
        const selectedRadios = popupInner.querySelectorAll(".birthstone_input.active");
        
        radio.classList.toggle(this.config.classes.active);
        
        if (radio.dataset.value === "Geen Geboortesteen") {
            birthstoneRadios.forEach(r => {
                if (r !== radio) r.classList.remove(this.config.classes.active);
            });
            return;
        }
        
        const geenGeboortesteen = popupInner.querySelector('.birthstone_input[data-value="Geen Geboortesteen"]');
        if (geenGeboortesteen) geenGeboortesteen.classList.remove(this.config.classes.active);
        
        if (selectedRadios.length > maxSelections) {
            selectedRadios[selectedRadios.length - 1].classList.remove(this.config.classes.active);
        }
    }

    handleSingleBirthstoneSelection(radio, popupInner) {
        const birthstoneRadios = popupInner.querySelectorAll(".birthstone_input");
        birthstoneRadios.forEach(r => r.classList.remove(this.config.classes.active));
        radio.classList.add(this.config.classes.active);
    }

    clearActiveRadios(container, specificClass = null) {
        if (!container) return;
        
        let selectors = "[data-radio-input]";
        if (specificClass) {
            selectors = `.${specificClass}[data-radio-input]`;
        }
        
        container.querySelectorAll(selectors).forEach(r => {
            r.classList.remove(
                this.config.classes.active, 
                this.config.classes.selected,
                this.config.classes.designShapeActive
            );
        });
    }

    updateBirthstoneImageForStep(step) {
        // const birthstoneImage = step.querySelector(".birthstone_main_product_image");
        // if (!birthstoneImage) return;

        // // const url = this.getBirthstoneImageUrlForStep(step);
        // if (url) {
        //     birthstoneImage.src = url;
        //     birthstoneImage.style.display = 'block';
        // }
    }

    updateAllBirthstoneImages() {
        // this.elements.steps.forEach(step => {
        //     if (step.dataset.stepType === 'birthstone') {
        //         this.updateBirthstoneImageForStep(step);
        //     }
        // });
    }

    updateColorImage(container, imageSrc) {
        // container?.querySelector(".mngm_color_main_img")?.setAttribute("src", imageSrc);
    }

    // getBirthstoneImageUrlForStep(step) {
    //     const bundleIndex = parseInt(step.dataset.bundleIndex) || 0;
    //     const startingStep = bundleIndex * this.state.originalStepCount;
        
    //     const materialStep = this.elements.steps[startingStep];
    //     const activeMaterial = materialStep?.querySelector(".material_inputs.active");
    //     const materialName = activeMaterial?.dataset?.matrialName;
        
    //     if (!materialName) return;
        
    //     const birthstoneInputs = step.querySelectorAll(".birthstone_input.active");    
    //     const monthNames = Array.from(birthstoneInputs).map(el => el.dataset.monthName).filter(name => name && name.toLowerCase() !== "none");
        
    //     if (monthNames.length > 0 && birthstoneInputs.length > 0) {
    //         const allActiveBirthstone = monthNames.join('_');
    //         return `/cdn/shop/files/necklace_${materialName}_${allActiveBirthstone}.png?&width=510`;
    //     }
        
    //     return `/cdn/shop/files/necklace_${materialName}.png?&width=510`;
    // }

    calculateTotalPrice() {
        const basePrice = parseFloat(this.elements.popup?.dataset.mainProductPrice || 0) * this.state.bundleCount;
        
        const birthstoneTotal = Array.from(document.querySelectorAll(".birthstone_input.active"))
            .reduce((sum, el) => sum + parseFloat(el.dataset.productPrice || 0), 0);
        
        const upsellTotal = Array.from(document.querySelectorAll(".upsell_input.active, .protection_warrenty_input.active"))
            .reduce((sum, el) => sum + parseFloat(el.dataset.productPrice || 0), 0);
        
        return basePrice + birthstoneTotal + upsellTotal;
    }

    updatePriceDisplays(totalPrice) {
        const formattedPrice = Shopify.formatMoney(totalPrice, window.money_format);
        
        if (totalPrice > 0 && this.elements.nextBtn) {
            this.elements.nextBtn.innerHTML = `${this.elements.nextBtn.dataset.nextbtnText || 'Next'} &nbsp; <span class='tgprice'>${formattedPrice}</span>`;
        }
        
        const addToCartBtn = document.querySelector("#addToCart"); 
        if (addToCartBtn) {
            addToCartBtn.querySelector(".tgprice").textContent = formattedPrice;
        }
        
        if (this.elements.popup) {
            this.elements.popup.dataset.monogramProductPrice = totalPrice;
        }
    }

    handleDesignSuggestion() {
        const currentStep = this.elements.steps[this.state.currentStep];
        const productNameInputs = Array.from(currentStep.querySelectorAll(".step_option_naam_input.active .name-input"));
        
        const inputValue = this.findMatchingName(productNameInputs);
        this.state.designExist = !!inputValue;

        this.updateDesignInterface(currentStep, inputValue);
    }

    findMatchingName(inputs) {
        for (const input of inputs) {
            const val = input.value.trim().toLowerCase();
            const match = this.state.namesOfArray.find(name => 
                name.toLowerCase() === val
            );
            if (match) return match;
        }
        return null;
    }

    updateDesignInterface(step, inputValue) {
        const nameContainer = step.querySelector(".input_name_design_wrapper");
        if (!nameContainer) return;

        nameContainer.parentElement.classList.toggle('design_exists', this.state.designExist);

        if (this.state.designExist) {
            this.renderExistingDesigns(nameContainer, inputValue);
        } else {
            this.renderDefaultDesigns(nameContainer);
        }
    }

    renderExistingDesigns(container, inputValue) {
        container.innerHTML = "";
        const versionTranslations = [
            container.getAttribute("data-version-one-translation") || container.getAttribute("varsion_one_translation"),
            container.getAttribute("data-version-two-translation") || container.getAttribute("varsion_two_translation")
        ];

        for (let i = 0; i < 2; i++) {
            const designElement = this.createVersionDesign(inputValue, i + 1, versionTranslations[i]);
            container.appendChild(designElement);
        }

        if (this.cache.customDesignElement) {
            container.appendChild(this.cache.customDesignElement.cloneNode(true));
        }
    }

    createVersionDesign(name, version, translation) {
        const div = document.createElement('div');
        div.className = 'image-item input_name_design existing_design_inputs';
        div.dataset.designName = `${name}_v${version}`;
        div.dataset.radioInput = true;
        
        const versionLabel = translation || `Version #${version}`;
        
        div.innerHTML = `
            <div class="version_design_bgd">
                <span>${versionLabel}</span>
            </div>
            <div class="existing_design_image">
                <img width="100%" height="100%" 
                     src="/cdn/shop/files/design_${name}_v${version}.png?&width=800" 
                     alt="${name}_v${version}" 
                     onerror="this.closest('.image-item').style.display = 'none'">
            </div>
        `;
        
        return div;
    }

    renderDefaultDesigns(container) {
        container.innerHTML = this.cache.preElement;
    }

    parseDesignNames() {
        if (!this.elements.designNames) {
            this.state.namesOfArray = [];
            return;
        }

        try {
            const rawText = this.elements.designNames.textContent.trim();
            const cleanedText = rawText.replace(/\n/g, '').replace(/\s+/g, ' ').trim();
            this.state.namesOfArray = cleanedText.split(',')
                .map(item => item.trim())
                .filter(item => item !== '');
        } catch (error) {
            console.error('Error parsing design names:', error);
            this.state.namesOfArray = [];
        }
    }

    cacheDesignElements() {
        const designWrapper = document.querySelector(".input_name_design_wrapper");
        this.cache.preElement = designWrapper?.innerHTML || '';
        this.cache.customDesignElement = document.querySelector(`[data-custom-design]`)?.cloneNode(true);
    }

    bindEvents() {
        this.bindStepNavigation();
        this.bindRadioSelections();
        this.bindInputEvents();
        this.bindPopupEvents();
        this.bindCustomEvents();

        this.bindDynamicElementEvents();
    }

    bindStepNavigation() {
        this.elements.nextBtn?.addEventListener('click', () => {
            this.handleNextButtonClick();
        });

        this.elements.backBtn?.addEventListener('click', () => {
            if (this.state.currentStep > 0) {
                this.showStep(this.state.currentStep - 1);
            }
        });
    }

    bindDynamicElementEvents() {
        document.addEventListener('click', (e) => {
            if (e.target.closest('.desing_read_reviews')) {
                e.target.closest('.design_review_container')?.classList.toggle('active');
            }

            if (e.target.closest('.mngm_popup_button') || e.target.closest('.mngm_popup_close')) {
                this.leesmeerClosePopup();
            }
        });
    }

    bindRadioSelections() {
        document.addEventListener('click', (e) => {
            const handlers = {
                '.input_name_design': () => this.handleDesignSelection(e),
                '.birthstone_input': () => this.handleRadioSelection(e.target.closest(".birthstone_input")),
                '.material_inputs': () => this.handleRadioSelection(e.target.closest(".material_inputs")),
                '.mngm_design_shape_item': () => this.handleRadioSelection(e.target.closest(".mngm_design_shape_item")),
                '.protection_warrenty_input': () => this.handleRadioSelection(e.target.closest(".protection_warrenty_input")),
                '.upsell_input': () => this.handleRadioSelection(e.target.closest(".upsell_input"))
            };

            Object.entries(handlers).forEach(([selector, handler]) => {
                if (e.target.closest(selector)) handler();
            });
        });
    }

    leesmeerOpenPopup() {
        if (!this.leesmeerPopup) {
            this.leesmeerPopup = document.getElementById('servicePopup');
        }
        this.leesmeerPopup?.classList.add('active');
    }

    leesmeerClosePopup() {
        if (!this.leesmeerPopup) {
            this.leesmeerPopup = document.getElementById('servicePopup');
        }
        this.leesmeerPopup?.classList.remove('active');
    }

    handleDesignSelection(e) {
        const clickedDesign = e.target.closest(".input_name_design");
        const popupInner = clickedDesign.closest("[data-mngm-popup-inner]");
        
        if (popupInner) {
            popupInner.querySelectorAll(".input_name_design").forEach(designElem => {
                designElem.classList.remove(this.config.classes.active);
            });
            clickedDesign.classList.add(this.config.classes.active);
        }
        this.updateButtonStates();
    }

    bindInputEvents() {
        document.addEventListener('input', (e) => {
            if (e.target.matches(".name-input")) {
                this.elements.nextBtn.disabled = !this.validateCurrentStep();
                if (this.validateCurrentStep()) {
                    this.handleDesignSuggestion();
                }
            }
        });

        document.addEventListener('change', (e) => {
            if (e.target.matches(".name-count-input")) {
                this.handleNameCountChange(e);
            }
        });
    }

    handleNameCountChange(e) {
        const inputValue = parseInt(e.target.value);
        const stepContainer = e.target.closest('.mngm_step_item');
        
        stepContainer.querySelectorAll(".step_option_naam_input")?.forEach((input, index) => {
            const isActive = index < inputValue;
            input.classList.toggle("mngm_d_none", !isActive);
            input.classList.toggle(this.config.classes.active, isActive);
            
            if (!isActive) {
                const nameInput = input.querySelector('.name-input');
                if (nameInput) nameInput.value = '';
            }
        });
        
        this.elements.nextBtn.disabled = !this.validateCurrentStep();
    }

    bindPopupEvents() {
        document.querySelectorAll(".product-form .main-product-form .product-form__submit")?.forEach(button => {
            button.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.openPopup();
            });
        });

        this.elements.overlay?.addEventListener("click", () => this.closePopupAndReset());
        this.elements.closeBtn?.addEventListener("click", () => this.closePopupAndReset());
    }

    openPopup() {
        this.elements.popup?.classList.add(this.config.classes.active);
        this.elements.overlay?.classList.add(this.config.classes.active);
        this.elements.wrapper?.classList.add(this.config.classes.active);
        document.body.classList.add("body-no-scrollbar");
        this.initializeSteps();
    }

    closePopup() {
        this.elements.popup?.classList.remove(this.config.classes.active);
        this.elements.overlay?.classList.remove(this.config.classes.active);
        this.elements.wrapper?.classList.remove(this.config.classes.active);
        document.body.classList.remove("body-no-scrollbar");
    }

    closePopupAndReset() {
        this.closePopup();
        this.resetToFirstStep();
    }

    resetToFirstStep() {
        this.state.currentStep = 0;
        this.state.currentBundleForm = 0;
        this.showStep(this.state.currentStep);
        this.updateBundleSwitcher();
    }

    bindCustomEvents() {
        document.addEventListener(this.config.events.stepFormEdit, () => {
            this.handleEditMode();
        });
    }

    handleEditMode() {
        this.openPopup();
        this.state.isEditing = true;
        
        const editFormId = sessionStorage.getItem("prefillCartItemId");
        const bundleQty = sessionStorage.getItem("productBundleSelcted");
        
        if (editFormId) {
            this.elements.popup?.setAttribute('data-edit-form-id', editFormId);
            
            if (bundleQty) {
                const bundleElement = document.querySelector(`.bundle-item[data-item="${bundleQty}"]`);
                if (bundleElement) {
                    bundleElement.click();
                }
            }
        }

        const storedData = JSON.parse(sessionStorage.getItem("cartItemData") || '[]');
        console.log("Edit mode - stored bundle data:", storedData);
        
        this.prefillAllBundles(storedData);
        
        this.initializeSteps();
        
        sessionStorage.removeItem('cartItemData');
        sessionStorage.removeItem('productBundleSelcted');
    }

    // New method to prefill all bundles
    prefillAllBundles(bundleDataArray) {
        if (!bundleDataArray || !Array.isArray(bundleDataArray)) return;
        
        // Ensure we have enough bundle forms
        if (bundleDataArray.length > this.state.bundleCount) {
            this.state.bundleCount = bundleDataArray.length;
            this.rebuildBundleForms();
        }
        
        bundleDataArray.forEach((bundleData, index) => {
            const startingStep = index * this.state.originalStepCount;
            // console.log(`Prefilling bundle ${index} starting at step ${startingStep}`, bundleData);
            this.prefillFormForBundle(bundleData, startingStep);
            
            // Update form data state
            this.state.formData[index] = {
                material: bundleData.materiaal || '',
                shape: bundleData.vorm || '',
                names: bundleData.naam || '',
                design: bundleData.stijl || '',
                birthstones: bundleData.geboortesteen || '',
                completed: true
            };
        });
        
        // Update bundle completion states
        for (let i = 0; i < bundleDataArray.length; i++) {
            this.state.bundleCompletion[i] = true;
        }
        
        this.updateBundleSwitcher();
        this.updateButtonStates();
    }

    prefillFormForBundle(bundleData, startingStep = 0) {
    if (!bundleData) return;

    // Use increasing delays to ensure proper sequencing
    const baseDelay = 500 + (startingStep * 300);

        setTimeout(() => {
            if (bundleData.materiaal) {
                this.prefillMaterial(bundleData.materiaal, startingStep);
            }
            
            if (bundleData.geboortesteen) {
                const birthstones = bundleData.geboortesteen.split(', ');
                setTimeout(() => {
                    this.prefillBirthstones(birthstones, startingStep);
                }, 800);
            }
            
            if (bundleData.naam) {
                setTimeout(() => {
                    this.prefillName(bundleData.naam, startingStep);
                }, 1200);
            }
            
            if (bundleData.stijl) {          
                setTimeout(() => {
                    this.prefillStyle(bundleData.stijl, startingStep);
                }, 1600);
            }

            // Add shape prefill
            if (bundleData.vorm) {
                setTimeout(() => {
                    this.prefillShape(bundleData.vorm, startingStep);
                }, 1000);
            }
            
            // Update active design image if available
            if (bundleData._active_design_img) {
                setTimeout(() => {
                    this.updateDesignImage(bundleData._active_design_img, startingStep);
                }, 2000);
            }
        }, baseDelay);
    }

    prefillFormWithCartData(cartItemData) {
        if (!cartItemData || Object.keys(cartItemData).length === 0) return;

        // Check if it's an array (multiple bundles) or object (single bundle)
        if (Array.isArray(cartItemData)) {
            // Multiple bundles
            this.prefillAllBundles(cartItemData);
        } else {
            // Single bundle - use existing logic for backward compatibility
            const extractedData = this.extractPreviousData(cartItemData);
            setTimeout(() => {
                this.prefillForm(extractedData);
                // console.log('Form pre-filled with edit data:', extractedData);
            }, 500);
        }
    }

    // Method to update design image for bundle
    updateDesignImage(imageSrc, startingStep = 0) {
        const designStep = this.elements.steps[startingStep + 3];
        if (!designStep) return;

        const activeDesign = designStep.querySelector(".input_name_design.active");
        if (activeDesign) {
            const designImg = activeDesign.querySelector("img");
            if (designImg) {
                designImg.src = imageSrc;
            }
        }
    }

    extractPreviousData(cartItemData) {
        const data = {};
        
        if (cartItemData.materiaal) {
            data.material = cartItemData.materiaal;
        }
        if (cartItemData.naam) {
            data.name = cartItemData.naam;
        }
        if (cartItemData.stijl) {
            data.style = cartItemData.stijl;
        }
        if (cartItemData.geboortesteen) {
            data.birthstones = cartItemData.geboortesteen.split(', ');
        }
        if (cartItemData.vorm) {
            data.shape = cartItemData.vorm;
        }
        
        return data;
    }

    prefillForm(previousData) {
        if (!previousData) return;

        // Prefill based on current bundle form (for multi-bundle editing)
        const startingStep = this.state.editBundleIndex * this.state.originalStepCount;
        
        if (previousData.material) {
            this.prefillMaterial(previousData.material, startingStep);
        }
        
        if (previousData.birthstones) {
            this.prefillBirthstones(previousData.birthstones, startingStep);
        }
        
        if (previousData.name) {
            this.prefillName(previousData.name, startingStep);
        }
        
        if (previousData.style) {          
            this.prefillStyle(previousData.style, startingStep);
        }

        // Add shape prefill
        if (previousData.shape) {
            this.prefillShape(previousData.shape, startingStep);
        }
    }
    
    prefillShape(shapeValue, startingStep = 0) {
        shapeValue = shapeValue.toLowerCase()
        const materialStep = this.elements.steps[startingStep];        
        
        if (!materialStep) {
            console.warn(`Material step not found for bundle starting at ${startingStep}`);
            return;
        }

        setTimeout(() => {
            const shapeInputs = materialStep.querySelectorAll('.mngm_design_shape_item');
            let found = false;
            
            shapeInputs.forEach(input => {
                const designName = input.getAttribute('data-shape-name');

                // console.log("designName === shapeValue", designName === shapeValue, designName, "===", shapeValue);
                if (designName === shapeValue) {
                    
                    input.classList.add(this.config.classes.designShapeActive);
                    found = true;
                    
                    setTimeout(() => {
                        input.click();
                    }, 100);
                    
                    this.updateShapeSelectionDisplay(input);
                }
            });
            
            if (!found) {
                console.warn(`Shape "${shapeValue}" not found for bundle starting at ${startingStep}`);
                const firstShape = materialStep.querySelector('.mngm_design_shape_item');
                if (firstShape) {
                    firstShape.classList.add(this.config.classes.designShapeActive);
                    setTimeout(() => {
                        firstShape.click();
                    }, 100);
                }
            }
        }, 200);
    }


    prefillMaterial(materialValue, startingStep = 0) {
        const materialStep = this.elements.steps[startingStep];
        if (!materialStep) {
            console.warn(`Material step not found for bundle starting at ${startingStep}`);
            return;
        }

        const materialInputs = materialStep.querySelectorAll('.material_inputs');
        let found = false;
        
        materialInputs.forEach(input => {
            const dataName = input.getAttribute('data-name');
            if (dataName === materialValue) {
                input.classList.add(this.config.classes.active);
                found = true;

                setTimeout(() => {
                    input.click();
                }, 100);
                
                const varColor = input.getAttribute('data-var-color');
                if (varColor) {
                    const mainImg = materialStep.querySelector('.mngm_color_main_img');
                    if (mainImg) {
                        mainImg.src = varColor;
                    }
                }
            } 
        });
        
        if (!found) {
            console.warn(`Material "${materialValue}" not found in bundle starting at ${startingStep}`);
        }
    }

    prefillBirthstones(birthstoneValues, startingStep = 0) {
        const birthstoneStep = this.elements.steps[startingStep + 1];
        if (!birthstoneStep) {
            console.warn(`Birthstone step not found for bundle starting at ${startingStep}`);
            return;
        }

        const birthstoneInputs = birthstoneStep.querySelectorAll('.birthstone_input');
        let foundCount = 0;
        
        birthstoneInputs.forEach(input => {
            const dataName = input.getAttribute('data-name');
            const dataValue = input.getAttribute('data-value');
            const isSelected = birthstoneValues.some(birthstone => 
                dataName === birthstone || dataValue === birthstone || dataName.includes(birthstone)
            );
            
            if (isSelected) {
                input.classList.add(this.config.classes.active);
                foundCount++;
            } 
        });
        
        // console.log(`Found ${foundCount} birthstones for bundle starting at ${startingStep}`);
    }

    prefillName(nameValue, startingStep = 0) {
        const nameStep = this.elements.steps[startingStep + 2];
        if (!nameStep) {
            console.warn(`Name step not found for bundle starting at ${startingStep}`);
            return;
        }

        let namesToPrefill = [nameValue];
        
        // Parse complex name formats like "#1-Naam-[name], #2-Naam-[name 2], #3-Naam-[name 3]"
        if (nameValue.includes('#') && nameValue.includes('Naam')) {
            namesToPrefill = this.parseComplexNames(nameValue);
        }
        
        const nameCountSelect = nameStep.querySelector('.name-count-input');
        const nameInputsContainer = nameStep.querySelector('.step_option_naam_inputs_container');
        const nameInputContainers = nameStep.querySelectorAll('.step_option_naam_input');
        
        if (nameCountSelect && nameInputsContainer) {
            const nameCount = namesToPrefill.length;
            nameCountSelect.value = nameCount.toString();
            
            const changeEvent = new Event('change', { bubbles: true });
            nameCountSelect.dispatchEvent(changeEvent);
            
            setTimeout(() => {
                const activeNameInputs = nameStep.querySelectorAll('.step_option_naam_input.active .name-input');
                
                namesToPrefill.forEach((name, index) => {
                    if (activeNameInputs[index]) {
                        activeNameInputs[index].value = name;
                        const inputEvent = new Event('input', { bubbles: true });
                        activeNameInputs[index].dispatchEvent(inputEvent);
                        // console.log(`Set name "${name}" for input ${index} in bundle ${startingStep / this.state.originalStepCount}`);
                    } else {
                        console.warn(`Name input ${index} not found for bundle starting at ${startingStep}`);
                    }
                });
                
                // console.log(`Set ${nameCount} names for bundle ${startingStep / this.state.originalStepCount}`);
            }, 100);
        } else {
            console.warn('Name count select or inputs container not found');
        }
    }

    parseComplexNames(complexNameString) {
        const names = [];
        const namePattern = /#\d+-Naam-\[([^\]]+)\]/g;
        let match;
        
        while ((match = namePattern.exec(complexNameString)) !== null) {
            names.push(match[1]);
        }
        
        return names.length > 0 ? names : [complexNameString];
    }

    prefillStyle(styleValue, startingStep = 0) {      
        const designStep = this.elements.steps[startingStep + 3];
        if (!designStep) {
            console.warn(`Design step not found for bundle starting at ${startingStep}`);
            return;
        }

        setTimeout(() => {        
            const designElement = designStep.querySelector(`.image-item.input_name_design[data-design-name="${styleValue}"]`);
            if (designElement) {
                designElement.classList.add(this.config.classes.active);
                // console.log(`Set design "${styleValue}" for bundle ${startingStep / this.state.originalStepCount}`);
            } else {
                console.warn(`Design "${styleValue}" not found for bundle starting at ${startingStep}`);
                // Try to find any active design as fallback
                const firstDesign = designStep.querySelector('.image-item.input_name_design');
                if (firstDesign) {
                    firstDesign.classList.add(this.config.classes.active);
                    // console.log(`Set first available design for bundle ${startingStep / this.state.originalStepCount}`);
                }
            }
        }, 100);
    }

    updateShapeSelectionDisplay(shapeElement) {
        const designName = shapeElement.dataset.desingShapeName;
        const shapeName = shapeElement.dataset.shapeName;
        
        const popupInner = shapeElement.closest("[data-mngm-popup-inner]");
        const materialName = popupInner?.querySelector(".material_inputs.active")?.dataset.matrialName || 'silver';

        const selectedValueElement = popupInner?.querySelector('[data-desing-selected-value]');
        if (selectedValueElement) {
            selectedValueElement.textContent = designName;
        }

        this.updateMaterialShapeMainImage(shapeName, popupInner, materialName);
    }

    updateMaterialShapeMainImage(shapeName, popupInner, matrialName) {
        const popupImage = popupInner?.querySelector(".mongm_material_shape_img img");
        if (popupImage) {
            popupImage.src = `/cdn/shop/files/shape_material_${shapeName}_${matrialName}.png?&width=572`;
        }
    }

    triggerCartRefresh() {
        document.dispatchEvent(new CustomEvent(this.config.events.cartRefresh, { 
            detail: { open: true }
        }));
    }

    destroy() {
        if (this.bundleObserver) {
            this.bundleObserver.disconnect();
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    try {
        window.monogramBundleManager = new MonogramBundleManager();
        
        window.selectBundle = function(element) {
            const wrapper = element.closest('.bundle-pricing-wrapper');
            wrapper.querySelectorAll('.bundle-item').forEach(item => {
                item.classList.remove('selected');
            });

            element.classList.add('selected');

            const bundleData = {
                item: element.getAttribute('data-item'),
                quantity: element.getAttribute('data-quantity'),
                price: element.getAttribute('data-bundle-item-price'),
                element: element
            };

            document.querySelector(".mngm_step_content_container").dataset.activeQuantityBundle = bundleData.item;
            document.querySelector("#monogram_popup").dataset.mainProductPrice = bundleData.price;

            document.dispatchEvent(new CustomEvent('bundleSelected', {
                detail: bundleData
            }));
        };
        
    } catch (error) {
        console.error('Failed to initialize MonogramBundleManager:', error);
    }
});


// ================================================================================
// =========== Main Product Price Update according to the bundle selcted ================
// =================================================================================
document.addEventListener("bundleSelected", (event) => {
    const mainProductPrice = document.querySelector(".product .product__info-wrapper .product__block--price");
    const actibeBundleItem = event.detail.element;
    
    if(!mainProductPrice && !actibeBundleItem) return;

    const bundlePrice = Shopify.formatMoney(actibeBundleItem.dataset.bundleItemPrice, window.money_format);
    const bundleComparePrice = Shopify.formatMoney(actibeBundleItem.dataset.productComparePrice, window.money_format);
    const bundleDiscountPercentage = actibeBundleItem.dataset.productDiscount;
    
    mainProductPrice.querySelector(".f-price-item--regular s").innerHTML = bundleComparePrice;
    mainProductPrice.querySelector(".f-price-item--sale").innerHTML = bundlePrice;
    mainProductPrice.querySelector(".f-badge--sale [data-sale-value]").innerHTML = bundleDiscountPercentage;
})

// ============================
// ======== Swiper ===============
// ============================

// var swiper = new Swiper(".mngm_name_slider", {
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
// });